import {AboutI18n} from '@/locales/base.message.locales';

export const about: AboutI18n = {
  title: 'ABOUT US',
  button: 'I WANT TO HELP',
  text: `
    <p class="pt-4">
                        We are a sum. Entrepreneurs, investors, non-conformist, executives,
                        United for something importante and essential: we were born by the
                        will of fighting misery in the Brazilian northeast, one of the most
                        beautiful regions in the world, but also one of the poorest of the
                        world from a social point of view. With time, we came to realize that
                        we are not alone, that it was possible to create a real Social League
                        across the world. A Social League made by people who are able to share
                        knowledge, ability and talento to bring out of all this the solutions
                        which our present time demands for healthcare, education, access to
                        information and many other fields.
                    </p>
                    <p>
                        We are a movement that needs to happen because life is precious enough
                        to be less than what it can be. We are a group that does not conform to
                        the things the way they are, that there isn’t a way out, that it has
                        always been like this. We believe and we act on promoting a powerful
                        innovation, ready to connect local transformers to global partnerships,
                        building bridges to what many considered impossible.But it is possible
                        to spread the development, come up with new models, develop lines, make it
                        on a global escale what we have done here. It will work in the northeast
                        of Brazil, it will work in all three American continents, it will change
                        the world.
                    </p>
                    <p>
                        But it is possible to spread the development, come up with new models,
                        develop lines, make it on a global escale what we have done here. It will
                        work in the northeast of Brazil, it will work in all three American
                        continents, it will change the world.
                    </p>`,
};
